exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-app-ads-txt-tsx": () => import("./../../../src/pages/app-ads.txt.tsx" /* webpackChunkName: "component---src-pages-app-ads-txt-tsx" */),
  "component---src-pages-flash-card-privacy-policy-tsx": () => import("./../../../src/pages/flash-card/privacy-policy.tsx" /* webpackChunkName: "component---src-pages-flash-card-privacy-policy-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

